// import React from 'react'
// import '../Item/Item.css'
// import { Link } from 'react-router-dom'

// const Item = (props) => {
//   const handleClick = () => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   return (
//     <div className='item'>
//       <Link to={`/product/${props.id}`} onClick={handleClick}>
//         <img 
//           src={props.image || "/placeholder.jpg"} 
//           alt={props.product_name} 
//         />
//       </Link>
//         {/* <p>{props.id}</p> */}
//       <p className="item-tescription">{props.type}</p>
//       <p className="item-title">{props.product_name}</p>
      
//       <div className="item-prices">
//         <div className="item-price-new">${props.new_price}</div>
//         <div className="item-price-old">${props.old_price}</div>
//       </div>

//       <p className="item-detail"><strong>Material:</strong> {props.material}</p>
//       <p className="item-detail"><strong>Color:</strong> {props.color}</p>
//     </div>
//   )
// }

// export default Item;
// import React from "react";
// import { Link } from "react-router-dom";
// import "./Item.css";

// const Item = ({
//   id,
//   image,
//   product_name,
//   pieces,
//   clothType,
//   type,
//   isNew,
//   productCode,
//   new_price,
//   old_price
// }) => {
//   return (
//     <div className="item-card">
//       <Link to={`/product/${id}`}>
//         <div className="item-image-wrapper">
//           {isNew && <span className="badge-new">NEW IN</span>}
//           <img src={image} alt={product_name} />
//         </div>
//       </Link>

//       <div className="item-info">
//         <p className="item-meta">
//           {pieces} {clothType && `- ${clothType} Suit`}
//         </p>

//         <p className="item-type">{type}</p>

//         <h3 className="item-title">{product_name}</h3>

//         <p className="item-code">{productCode}</p>

//         <div className="item-prices">
//           <span className="price-new">Rs. {new_price}</span>
//           {old_price && <span className="price-old">Rs. {old_price}</span>}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Item;
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Item.css";

const Item = ({
  id,
  image,
  product_name,
  productCode,
  pieces,
  clothType,
  type,
  isNew,
  new_price,
  old_price
}) => {
  const [hover, setHover] = useState(false);

  const discount =
    old_price && new_price
      ? Math.round(((old_price - new_price) / old_price) * 100)
      : null;

  return (
    <div
      className="item-card"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Link to={`/product/${id}`}>
        <div className="item-image-wrapper">
          {isNew && <span className="badge-new">NEW IN</span>}
          {discount && <span className="badge-discount">-{discount}%</span>}

          <img
            src={image}
            alt={product_name}
            loading="lazy"
          />
        </div>
      </Link>

      <div className="item-info">
        <p className="item-meta d-none">
          {pieces} {clothType && `- ${clothType}`}
        </p>

        <p className="item-type d-none">{type}</p>

        <h3 className="item-title ">{product_name}</h3>

        <p className="item-code d-none">{productCode}</p>

        <div className="item-prices">
          <span className="price-new">Rs. {new_price}</span>
          {old_price && <span className="price-old">Rs. {old_price}</span>}
        </div>
      </div>
    </div>
  );
};

export default Item;
